import Link from "../Link";

const Java = () => {
    return (
        <div>
            <Link url="https://campus.open-bootcamp.com/cursos/5" title={"OpenBootcamp Java Básico"} />
            <Link url="https://campus.open-bootcamp.com/cursos/9" title={"OpenBootcamp Java Avanzado"} />
            <Link url="https://campus.open-bootcamp.com/cursos/48" title={"OpenBootcamp Curso Extra Android"} />
        </div>
    );
}

export default Java;